import React, { useState } from 'react'
import { Box } from '@mui/material'
import { Field, Form, Formik, ErrorMessage } from 'formik'
import * as yup from 'yup'
import { parse, format } from 'date-fns'

// Local Imports
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import AdxInput from 'components/custom/AdxInput'
import AdxDatePicker from 'components/custom/AdxDatePicker'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'

// API services
import { useUpdateCustomHoliday } from 'services/api/modules/leave/holiday'
import AdxButton from 'components/custom/AdxButton'

const EditCustomHolidayForm = ({ state }) => {
  const [modalState, setModalState] = useState(false)
  const mutation = useUpdateCustomHoliday()

  const handleOpen = () => {
    setModalState(true)
  }

  const handleClose = () => {
    setModalState(false)
  }

  const validationSchema = yup.object().shape({
    name: yup.string().required('Name is required'),
    date: yup.mixed().required('Please select a date').nullable(),
  })
  return (
    <>
      <AdxButton variant={'ghost'} size="small" color="alternate" onClick={handleOpen}>
        Edit
      </AdxButton>

      <Formik
        initialValues={{
          name: state.name,
          date: parse(state.date, 'dd/MM/yyyy', new Date()),
          type: state.type,
        }}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          const postData = {
            holiday: [
              {
                name: values.name,
                date: format(values.date, 'yyyy/MM/dd'),
                type: values.type,
              },
            ],
          }
          mutation.mutate(
            { postData, id: state.id },
            {
              onSuccess: () => {
                handleClose()
              },
            }
          )
        }}
      >
        {({ handleChange, handleBlur, setFieldValue, handleSubmit, errors, touched, values }) => {
          return (
            <Form>
              <AdxFormModal
                title="Edit Custom Holiday"
                subtitle=""
                open={modalState}
                onClose={handleClose}
                handleClose={handleClose}
                sxModal={{
                  width: { xs: '100vw', lg: '500px' },
                }}
                enableFooter
                actionText="Save"
                handleAction={handleSubmit}
              >
                <Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Field
                      name={`name`}
                      as={AdxInput}
                      charLimit={50}
                      errorMessage={<ErrorMessage name={`name`} component={AdxErrorMessage} />}
                      isErrorShown={errors.name && touched.name}
                      sx={{ width: 1 }}
                      label="Custom Holiday Name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <Field
                      name={`date`}
                      as={AdxDatePicker}
                      errorMessage={<ErrorMessage name={`date`} component={AdxErrorMessage} />}
                      isErrorShown={errors.date && touched.date}
                      label="Select Holiday Date"
                      type="date"
                      onChange={(e) => {
                        setFieldValue(`date`, e)
                      }}
                      onBlur={handleBlur}
                    />
                  </Box>
                </Box>
              </AdxFormModal>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

export default EditCustomHolidayForm
